import { observer } from "mobx-react-lite";
import * as React from "react";
import styles from "./EntityHistory.module.less";
import { EntityStatesHistory } from "./EntityStatesHistory";
import { EntityHistoryStore } from "./EntityHistoryStore";
import { StateView } from "../../../components/StateView";
import { EntityAttsHistory } from "./EntityAttsHistory";
import { EntityAudit } from "./EntityAudit";
import { EntityAuditStore } from "./EntityAudit/EntityAuditStore";

interface PropsEntityHistory {
  store: EntityHistoryStore;
  auditStore: EntityAuditStore;
}

export const EntityHistory: React.FC<PropsEntityHistory> = observer(
  ({ store, auditStore }) => {
    const curStateView = store.curStateName ? (
      <StateView name={store.curStateName} />
    ) : undefined;

    return (
      <div className={styles.frame}>
        <div className={styles.header}>
          <div className={styles.title}>{store.entityName}</div>
          {curStateView}
        </div>
        <div className={styles.mainPart}>
          <EntityStatesHistory store={store.statesStore} />
          <EntityAudit store={auditStore} entityId={store.entityId} />
          <EntityAttsHistory store={store.attsStore} />
        </div>
      </div>
    );
  },
);
